import React, { useState } from 'react';
import ClientSidebar from '../ClientSidebar';
import ClientBottomNav from '../ClientBottomNav';
import { ClientPageHeader, ClientGuideCallout } from '../../client/guidance';
import { CLIENT_PAGE_GUIDES } from '../../../utils/clientPageGuides';

/**
 * Authenticated client account shell.
 * Header + guide sit in the main column beside the sidebar.
 */
const ClientPageLayout = ({
  children,
  title = 'My Account',
  subtitle = null,
  actions = null,
  guideKey = null,
  guideTone = 'sky',
  showHeader = true,
}) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const guide = guideKey ? CLIENT_PAGE_GUIDES[guideKey] : null;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-16 lg:pb-0 transition-colors">
      <div className="page-container py-5 sm:py-6 md:py-8 px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row gap-5 lg:gap-6">
          <ClientSidebar
            isMobileOpen={isMobileSidebarOpen}
            onClose={() => setIsMobileSidebarOpen(false)}
          />

          <div className="flex-1 w-full min-w-0 space-y-5">
            {showHeader && title ? (
              <>
                <ClientPageHeader title={title} subtitle={subtitle} actions={actions} />
                {guide ? (
                  <ClientGuideCallout
                    title={guide.title}
                    steps={guide.steps}
                    tone={guideTone}
                  />
                ) : null}
              </>
            ) : null}
            {children}
          </div>
        </div>
      </div>

      <ClientBottomNav />
    </div>
  );
};

export default ClientPageLayout;
